module.exports = __webpack_public_path__ + "img/3-en.05542397.png";